/**
 * 快讯页面js
 */

var Handlebars = require('./modules/handlebars/handlebars');
var datetime = require('./modules/datetime/datetime');
var gotop = require('./modules/gotop/gotop');
var share = require('./modules/share/share');
var tts = require('./modules/tts/tts');


var kxitem_template = Handlebars.compile($("#kxitem_template").html());

//显示快讯时间
Handlebars.registerHelper('kxtime', function(date) {
	if (date == '') {
		return '';
	}
	var html = '';
	var thisdate = datetime.dateFormat(new Date(), 'yyyy-MM-dd');
	var yesterday = datetime.dateFormat(new Date(new Date().getTime() - 24*60*60*1000), 'yyyy-MM-dd');
	if(date.substring(0, 10) == thisdate){ //今天
		html = date.substring(11, 16);
	}
	else if(date.substring(0, 10) == yesterday){ //昨天
		html = date.substring(11, 16) + '<br>昨天';
	}
	else{
		html = date.substring(11, 16) + '<br>' + date.substring(5, 10).replace('-','/');
	}

	return new Handlebars.SafeString(html);
});

//快讯链接
Handlebars.registerHelper('kxlink', function(newstype, newsid) {
	return getKuaixunLink(newstype, newsid);
});

//快讯文本
Handlebars.registerHelper('kxtext', function(newstype, digest, title) {
	return getKuaixunText(newstype, digest, title);
});

//快讯图片
Handlebars.registerHelper('show_kximg', function(Art_24Image, Art_24ImageHQT) {
	var imghtml = '';
	if (Art_24ImageHQT != null && Art_24ImageHQT != '') {
		var codearray = Art_24ImageHQT.split('|');
		if (codearray.length >= 3) {
			var imgurl = 'http://pifm3.eastmoney.com/EM_Finance2014PictureInterface/Index.aspx?id=' + codearray[0] + codearray[1] + '&imageType=FIKS&token=5c46f660fab8722944521b8807de07c0';
			if (codearray[2] == 'R') {
				imgurl = 'http://pifm3.eastmoney.com/EM_Finance2014PictureInterface/Index.aspx?id=' + codearray[0] + codearray[1] + '&imageType=FIRS&token=5c46f660fab8722944521b8807de07c0';
			}
			imghtml = '<div class="stockimg"><a href="http://m2.quote.eastmoney.com/h5stock/' + codearray[0] + codearray[1] + '.html"><img src="' + imgurl + '" alt=""></a></div>';
		}
	}
	else if(Art_24Image != null && Art_24Image != ''){
		imghtml = '<div class="stockimg"><img src="' + Art_24Image + '" alt=""></div>';
	}

	return new Handlebars.SafeString(imghtml);
});

//快讯链接
function getKuaixunLink(newstype, newsid){
	var link = '';
	if(newstype == 1 || newstype == 2){
		link = 'http://wap.eastmoney.com/3g/news/article,8,365,1,' + newsid + '.shtml';
	}
	else if(newstype == 3 ){
		link = 'http://wap.eastmoney.com/3g/report/article,research,' + newsid.substring(0, 8) + ',' + newsid.substring(8) + '_1.shtml';
	}
	else if(newstype == 4){
		link = 'http://wap.eastmoney.com/3g/report/article,industry,' + newsid.substring(0, 8) + ',' + newsid.substring(8) + '_1.shtml';
	}

	return link;
}

function getKuaixunText(newstype, digest, title){
	var text = title;
	if(newstype == 1 || newstype == 2){
		if (digest != '') {
			text = digest;
		}
	}
	return text;	
}

var kuaixun = {
	init: function (){
		this.datalist = {};
		this.bind();
		this.nowtype = '102';

		if (kxdtype) {
			$('#kxtabs li').removeClass('on');
			switch (kxdtype){
				case 'yw':
					this.nowtype = '101';
					$('#kxtabs li').eq(1).addClass('on');
					break;
				case 'zhibo':
					this.nowtype = 'zhibo';
					$('#kxtabs li').eq(2).addClass('on');
					break;
				case 'ssgs':
					this.nowtype = '103';
					$('#kxtabs li').eq(3).addClass('on');
					break;
				default:
					this.nowtype = '102';
					$('#kxtabs li').eq(0).addClass('on');
					break;
			}
		}

		this.nowpage = 1;
		this.isloading = false;
		this.filldata();
		this.checknew();
	},
	/**
	 * 绑定事件
	 * @return {[type]} [description]
	 */
	bind: function (){
		var _this = this;

		//页面滚动 tab
		var kxtabs = $('#kxtabs');
		var tabtop = kxtabs.offset().top;
		$(window).scroll(function() {
	        if ($(window).scrollTop() > tabtop) {
	            kxtabs.css({position:'fixed', top:0, 'z-index':2});
	        } else {
	            kxtabs.css({position:'static'});
	        }
	    });  		

		//绑定tab切换
		// $('#kxtabs').on('click','li', function (){
		// 	$('#kxtabs li').removeClass('on');
		// 	$(this).addClass('on');
		// 	var typeid = $(this).data('typeid');
		// 	_this.nowtype = typeid;
		// 	_this.nowpage = 1;
		// 	_this.filldata('replace');
		// 	$('#kxnew').hide();
		// 	if ($(window).scrollTop() > tabtop) {
		// 		window.scrollTo(0, tabtop);
		// 	}
		// });

		//加载更多
		var loadingtime = null;
		$(window).scroll(function() {
			var kxloading = $('#kxloading');
			clearTimeout(loadingtime);
	        if ($(window).scrollTop() >= kxloading.offset().top - $(window).height() - 30) {
	            loadingtime = setTimeout(function(){
	            	_this.loadingmore();
	            },400);
	        }
	    });  

		//绑定展开收起按钮
		$('#kxlist').on('click', '.kxopentext', function (){
			$(this).prevAll('.kxtextb').addClass('kxtextb_zk');
			$(this).nextAll('.kxclosetext').show();
			$(this).parents('.kxitem').find('.kxlink').show();
			$(this).hide();
			return false;
		});
		$('#kxlist').on('click', '.kxclosetext', function (){
			$(this).prevAll('.kxtextb').removeClass('kxtextb_zk');
			$(this).prevAll('.kxopentext').show();
			$(this).parents('.kxitem').find('.kxlink').hide();
			$(this).hide();
			return false;
		});

		$('#kxlist').on('click', '.kxtextb', function (){
			if ($(this).data('showzk') != 'yes') {
				return true;
			}
			if ($(this).is('.kxtextb_zk')) {
				$(this).removeClass('kxtextb_zk');
				$(this).nextAll('.kxclosetext').hide();
				$('.kxlink', this).hide();
				$(this).nextAll('.kxopentext').show();
			}
			else{
				$(this).addClass('kxtextb_zk');
				$(this).nextAll('.kxclosetext').show();
				$('.kxlink', this).show();
				$(this).nextAll('.kxopentext').hide();
			}
		});		


		//语音播放
		$('#kxlist').on('click', '.kxaudio', function (){
			$('#kxlist .playing').removeClass('playing');
			$(this).addClass('playing')

			var id = $(this).data('id');
			tts.play(id);
			return false;
		});

		
		$('#kxnew').on('click', function (){
			_this.filldata('replace');
			$('#kxnew').hide();
		});



	},
	//检查更新
	checknew : function (){
		var _this = this;
		this.checknewtimer = setInterval(function(){
			var firstid = $('#kxlist .kxitem:first').data('id');
			$.ajax({
				url: 'http://newsapi.eastmoney.com/kuaixun/v2/api/list?callback=?',
				//url: 'http://172.16.86.11:8055/kuaixun/v2/api/list?callback=?',				
				type: 'GET',
				dataType: 'jsonp',
				data: {
					column: _this.nowtype,
					id: firstid,
					count: 'count'
				},
			})
			.done(function(json) {
				if (json.rc) {
					if(json.count > 0){
						$('#kxnew').show();
						$('#kxnewcount').text(json.count);
					}
				}
			})
			.fail(function() {
				//console.log("error");
			})
			.always(function() {
				//console.log("complete");
			});
		},30*1000);
	},
	loadingmore: function (){
		if (this.isloading) {
			return false;
		}	
		this.isloading = true;
		this.nowpage ++;
		this.filldata('append', function (){
			this.isloading = false;
		}.bind(this));

	},
	filldata: function (filltype, callback){
		var _this = this;
		this.getdata(this.nowtype, this.nowpage, function (json){
			if (json.rc == 0 || json.news.length <= 0) {
				return false;
			}

			var datahtml = $(this.makehtml(json));
			//console.info(datahtml);
			if(filltype == 'prepend'){
				$('#kxlist').prepend(datahtml);
			}
			else if(filltype == 'replace'){
				$('#kxlist').html(datahtml);
			}
			else{
				$('#kxlist').append(datahtml);
			}
			
			//console.info($('.kxitem', datahtml));
			//显示展开按钮
			datahtml.each(function (){
				var kxtextb = $('.kxtextb', this);
				var kxtextbspan = $('.kxtextb span', this);
				var kxopentext =  $('.kxopentext', this);
				if(kxtextbspan.height() > kxtextb.height()){
					kxopentext.show();
					kxtextb.data('showzk', 'yes');
				}
				else{
					$('.kxtextb', this).addClass('kxtextb_zk');
					$('.kxlink', this).show();
				}

				$('.kxshare', this).on('click', function (){
					var id = $(this).data('id');
					share.show({
						title: _this.datalist[id].title,
						url: getKuaixunLink(_this.datalist[id].newstype, _this.datalist[id].newsid),
						des: getKuaixunText(_this.datalist[id].newstype, _this.datalist[id].digest, _this.datalist[id].title)
					});
					return false;
				});

			});

			//tts
			var ttsdata = [];
			json.news.forEach(function (v, i){
				var text = v.title;
				if(v.newstype == 1 || v.newstype == 2){
					if (v.digest != '') {
						text = v.digest;
					}
				}

				ttsdata.push({
					id: v.id,
					text: text
				});

				this.datalist[v.id] = v;

			}.bind(this));

			
			if(filltype == 'prepend'){
				//$('#kxlist').prepend(datahtml);
			}
			else if(filltype == 'append'){
				tts.appendData(ttsdata);
			}
			else{
				tts.init({audiolist: ttsdata});
			}
			

			if(callback){
				callback();
			}
		}.bind(this));	
	},
	getdata: function (typeid, page, succ){
		$.ajax({
			url: 'http://newsapi.eastmoney.com/kuaixun/v2/api/list?callback=?',
			//url: 'http://172.16.86.11:8055/kuaixun/v2/api/list?callback=?',			
			type: 'GET',
			dataType: 'jsonp',
			data: {
				column: typeid,
				p: page,
				limit: 50
			},
		})
		.done(function(json) {
			if (json.rc) {
				succ(json);
			}
		})
		.fail(function() {
			//console.log("error");
		})
		.always(function() {
			//console.log("complete");
		});
	},
	makehtml: function (json){
		return kxitem_template(json);
	}
}


kuaixun.init();	

// $('body').on('mousedown', function (e){
// 	console.info(e.target);
// })


gotop.init();


//////////////////
// WEBPACK FOOTER
// ./dev/kuaixun.js
// module id = 0
// module chunks = 11